import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const useWorkspaceFilesStyles = makeStyles({
  contextFilesLayout: {
    flex: 1,
    overflowY: "auto",
    padding: designTokens.spacing[8],
  },
  contextFilesContent: {
    maxWidth: "1120px",
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[4],
  },
});
